import { RadioElement } from 'Modules/ui3';

import { ListForTranslate } from '../../../utils';
import { InvestorStatus, InvestorType } from '../types';


export const investorTypes: ListForTranslate<RadioElement> = [
    {
        tKey: 'investorTypes.person',
        value: InvestorType.FL,
    },
    {
        tKey: 'investorTypes.company',
        value: InvestorType.UL,
    },
    {
        tKey: 'investorTypes.individual',
        value: InvestorType.IP,
    },
];

export const investorStatus: ListForTranslate<RadioElement> = [
    {
        tKey: 'investorStatus.qualified',
        value: InvestorStatus.QUALIFIED,
    },
    {
        tKey: 'investorStatus.noneQualified',
        value: InvestorStatus.NONE_QUALIFIED,
    },
];
